import clsx from 'clsx';

// Types
import type { ReportFormProps } from '@/components/pages/reports/CreateEditPage/components/ReportForm';

type ReportFormBodyLoadingProps = Pick<ReportFormProps, 'isEdit'>;

const ReportFormBodyLoading = ({ isEdit }: ReportFormBodyLoadingProps) => (
    <div className="flex w-full flex-row space-x-10" data-testid="report-form-body-loading">
        <div className="flex flex-1 flex-col space-y-8">
            <div className="flex w-full flex-col space-y-3">
                <span className="block h-8 w-1/3 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <hr />
            </div>
            <div className="flex flex-col space-y-3">
                <span className="block h-5 w-1/2 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <span className="block h-12 w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
            </div>
            <div className="flex flex-col space-y-3">
                <span className="block h-5 w-1/2 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <span className="block h-12 w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
            </div>
            <div className="flex w-full flex-col space-y-3">
                <span className="block h-8 w-1/3 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <hr />
            </div>
            <div className="flex flex-col space-y-3">
                <span className="block h-5 w-1/2 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <span className="block h-12 w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
            </div>
            <div className="flex flex-col space-y-3">
                <span className="block h-5 w-1/2 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <span className="block h-12 w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
            </div>
        </div>
        <div className="flex flex-1 flex-col space-y-8">
            <div className="flex w-full flex-col space-y-3">
                <span className="block h-8 w-1/3 animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite" />
                <hr />
            </div>
            <div
                className={clsx(
                    'w-full animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-anthracite',
                    { 'h-80': !isEdit, 'h-12': isEdit }
                )}
            />
        </div>
    </div>
);

export default ReportFormBodyLoading;
